<template>
  <div>
    <EstimatesTable
      class="mb-4"
      :items="estimations"
      :task-types="currentProjectTaskTypes"
      :roles="estimationRoles"
      @afterImport="loadEstimates(project.id)"
    />
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';

import EstimatesTable from '@/components/projects/EstimatesTable.vue';

export default {
  components: {
    EstimatesTable,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },

  computed: {
    ...mapGetters('projects/main', [
      'projectEstimations',
      'projectEstimationRoles',
    ]),
    ...mapGetters('auth/account', ['user']),
    ...mapGetters('projects/main', ['search']),

    ...mapGetters('shared/taskTypes', [
      'projectsTaskTypes',
    ]),

    currentProjectTaskTypes() {
      return this.projectsTaskTypes[this.project.id] || [];
    },

    estimationRoles() {
      return this.projectEstimationRoles;
    },

    estimations() {
      return this.projectEstimations;
    },
  },
  mounted() {
    this.loadEstimates(this.project.id);
  },
  beforeDestroy() {},
  methods: {
    ...mapActions('projects/main', [
      'getProjectEstimations',
      'getProjectEstimationRoles',
    ]),
    ...mapActions('shared/taskTypes', [
      'getProjectsTaskTypes',
    ]),
    async loadEstimates(projectId) {
      await this.getProjectsTaskTypes({ projectIds: [projectId] });
      await this.getProjectEstimations({ projectId });
      await this.getProjectEstimationRoles({ projectId });
    },
  },
};
</script>

<style lang="less"></style>
